import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-term-full-text-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslocoModule],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <pre class="full-text">{{ data.fullText }}</pre>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>{{ 'common.close' | transloco }}</button>
    </mat-dialog-actions>
  `,
  styles: ['.full-text { white-space: pre-wrap; word-break: break-word; max-height: 60vh; overflow-y: auto; font-family: inherit; }'],
})
export class TermFullTextDialogComponent {
  protected readonly data = inject<{ title: string; fullText: string }>(MAT_DIALOG_DATA);
}
